export const environment = {
  //local
  // production: true,
  // string: "test",
  // ssourl: 'https://localhost:7019/api/WeatherForecast/Test',
  // apiurl: 'https://localhost:7019/api/',
  // logouturl: 'https://localhost:7019/api/WeatherForecast/Test?action=logout',
  // experimentseturl: 'https://localhost:7019/',
  // domain: "HKCC",
  // i18n: "/assets/json/i18n/"

  //DEV
  // production: true,
  // string: "test",
  // ssourl: 'https://win-n0n2ooq0ecp/dmsadfs/adfs-sso.aspx',
  // apiurl: 'https://win-n0n2ooq0ecp/FRSWebAPI/api/',
  // logouturl: 'https://win-n0n2ooq0ecp/dmsadfs/adfs-sso.aspx?action=logout',
  // experimentseturl: 'https://win-n0n2ooq0ecp/',
  // domain: "HKCC",
  // i18n: "/FRSWeb2/assets/json/i18n/"

  //UAT
  // production: true,
  // string: "test",
  // ssourl: 'https://UAT-FRS-Web/dmsadfs/adfs-sso.aspx',
  // apiurl: 'https://UAT-FRS-Web/FRSWebAPI/api/',
  // logouturl: 'https://UAT-FRS-Web/dmsadfs/adfs-sso.aspx?action=logout',
  // experimentseturl: 'https://UAT-FRS-Web/',
  // domain: "HKCC",
  // i18n: "/assets/json/i18n/"

    //PRO-in
    // production: true,
    // string: "test",
    // ssourl: 'https://PRO-FRS-Web/dmsadfs/adfs-sso.aspx',
    // apiurl: 'https://PRO-FRS-Web/FRSWebAPI/api/',
    // logouturl: 'https://PRO-FRS-Web/dmsadfs/adfs-sso.aspx?action=logout',
    // experimentseturl: 'https://PRO-FRS-Web/',
    // domain: "HKCC",
    // i18n: "/booking/assets/json/i18n/"

    //PRO-ex
    production: true,
    string: "test",
    ssourl: 'https://ccrlab.hkcc-polyu.edu.hk/dmsadfs/adfs-sso.aspx',
    apiurl: 'https://ccrlab.hkcc-polyu.edu.hk/FRSWebAPI/api/',
    logouturl: 'https://ccrlab.hkcc-polyu.edu.hk/dmsadfs/adfs-sso.aspx?action=logout',
    experimentseturl: 'https://ccrlab.hkcc-polyu.edu.hk/',
    domain: "HKCC",
    i18n: "/booking/assets/json/i18n/"
};
